// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fdsPt","top":"styles_top__mMaBo","left":"styles_left__bpUN1","description":"styles_description__m9u_Y"};